import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  closePwChangePopup,
  getIntroConfig,
  onLoginConnect,
  resetTwoFactorAuth,
  requestOtp,
  resolveTwoFactorAuth,
  checkTwoFactAuthExpiration
} from "../AuthReducer";
import { useDispatch, useSelector } from "react-redux";
import LogoTag from "../../components/atoms/logo";
import Footer from "../../components/organisms/footerBasic/mobileIndex";
import "./MobileIntroContainer.scss";
import LoginForm from "../../components/organisms/loginForm";
import TwoFactorAuthPopup from "../component/TwoFactorAuthPopup";
import YesConfirmPopup from "../../components/common/yesConfirm";
import LanguageSwitcher from "../../components/common/languageSwitcher";

const MobileIntroContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { introConfig, pwChangePopupFlag, twoFactorAuth } = useSelector(
    (state) => state.auth
  );
  const [connectUserID, setConnectUserID] = useState(localStorage.getItem("connect_user_ID"));
  const [rememberUserId, setRememberUserId] = useState(localStorage.getItem("remember_user_ID"));
  const welcomeLines = t("intro.welcome.mobile").split("\n");

  useEffect(() => {
    dispatch(getIntroConfig());
  }, [dispatch]);

  useEffect(() => {
    if (localStorage.getItem("remember_user_ID") === null || localStorage.getItem("remember_user_ID") === false) {
      setRememberUserId(false);
      setConnectUserID("");
      return;
    }
  }, []);

  return (
    <div
      className="mobile-intro-layout"
      style={{
        backgroundImage: introConfig?.introBackgroundImage 
          ? `url(${introConfig.introBackgroundImage})` 
          : "url(assets/images/intro/layout_intro_bg1.jpg)",
      }}
    >
      <div style={{ position: "absolute", top: 12, right: 16, zIndex: 2 }}>
        <LanguageSwitcher />
      </div>
      <div className="mobile-intro-content">
        <div className="intro-text">
          <LogoTag width="160"></LogoTag>
          <h2>
            {welcomeLines.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < welcomeLines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </h2>
        </div>
        <div className="login-form-box">
          {introConfig && (
            <>
              <LoginForm
                onLogin={(req) =>
                  dispatch(onLoginConnect(req, rememberUserId))
                }
                title={t("login.title.mobile")}
                config={introConfig}
                findUserID={null}
                resetPassword={null}
                changeUserPw={null}
                closePwChangePopup={() => dispatch(closePwChangePopup())}
                onClickSignUp={null}
                pwChangePopupFlag={pwChangePopupFlag}
                localStorageId={connectUserID}
                setRememberUserId={(rememberUserId) => {
                  setRememberUserId(rememberUserId);
                  localStorage.setItem("remember_user_ID", rememberUserId);
                }}
                rememberUserId={rememberUserId}
              />
              {twoFactorAuth != null && (
                <TwoFactorAuthPopup
                  maxWidth="90%"
                  title={twoFactorAuth.title}
                  target={twoFactorAuth.target}
                  authMethod={twoFactorAuth.authMethod}
                  checkExpiration={(callbackFn) => dispatch(checkTwoFactAuthExpiration(callbackFn))}
                  onSubmit={(req, callbackFn) => dispatch(resolveTwoFactorAuth(req.code, callbackFn))}
                  requestOtp={(callback) => dispatch(requestOtp(callback))}
                  closePopup={() => dispatch(resetTwoFactorAuth())}
                />
              )}
            </>
          )}
        </div>
      </div>
      <Footer theme="light" />
      <YesConfirmPopup />
    </div>
  );
};
export default MobileIntroContainer;
